module.exports = __webpack_public_path__ + "static/Batflat-30f87fe02fc87b39f2e8c5b92b4b2c13.svg";